import { CITIES } from '@/lib/locations';

/**
 * The Dallas–Fort Worth cities KIT serves, drawn as dots in their real
 * relative positions (approximate centre of each city). Dallas pulses; the
 * size of a dot follows its priority. Purely decorative: the city links next
 * to it carry the meaning.
 */

const GEO: Record<string, [number, number]> = {
  dallas: [32.78, -96.8],
  irving: [32.81, -96.95],
  garland: [32.91, -96.64],
  richardson: [32.95, -96.73],
  mesquite: [32.77, -96.6],
  addison: [32.96, -96.83],
  plano: [33.02, -96.7],
  frisco: [33.15, -96.82],
  carrollton: [32.95, -96.89],
  'grand-prairie': [32.75, -97.0],
  arlington: [32.74, -97.11],
};

const W = 260;
const H = 170;
const pos = (lat: number, lon: number) => ({ x: 18 + ((lon + 97.16) / 0.62) * (W - 36), y: 16 + ((33.2 - lat) / 0.5) * (H - 40) });

export function DfwMap({ className = '', labels = false }: { className?: string; labels?: boolean }) {
  const dallas = pos(...GEO.dallas);
  return (
    <svg viewBox={`0 0 ${W} ${H}`} className={className} aria-hidden="true">
      {/* Highways, roughly: I-35E, I-30, I-635 loop. Just enough to read as a map. */}
      <g fill="none" stroke="currentColor" strokeOpacity="0.16" strokeWidth="1.4" strokeLinecap="round">
        <path d={`M ${pos(33.2, -96.86).x} 0 L ${dallas.x - 4} ${dallas.y} L ${pos(32.5, -96.84).x} ${H}`} />
        <path d={`M 0 ${pos(32.74, -97.2).y} L ${dallas.x} ${dallas.y} L ${W} ${pos(32.8, -96.5).y}`} />
        <ellipse cx={dallas.x + 4} cy={dallas.y - 10} rx="58" ry="34" />
      </g>
      {CITIES.map((c) => {
        const g = GEO[c.slug];
        if (!g) return null;
        const p = pos(...g);
        const r = c.priority === 1 ? 7 : c.priority === 2 ? 4.5 : 3.5;
        return (
          <g key={c.slug}>
            {c.priority === 1 && (
              <circle cx={p.x} cy={p.y} r={r} className="dfw-pulse" fill="var(--color-signal)" />
            )}
            <circle cx={p.x} cy={p.y} r={r} fill={c.priority === 1 ? 'var(--color-signal)' : 'currentColor'} fillOpacity={c.priority === 1 ? 1 : c.priority === 2 ? 0.85 : 0.55} />
            {labels && (
              <text x={p.x + r + 3} y={p.y + 3.5} fontSize="9" fontWeight={c.priority === 1 ? 700 : 500} fill="currentColor" fillOpacity={c.priority === 1 ? 1 : 0.7}>
                {c.name}
              </text>
            )}
          </g>
        );
      })}
    </svg>
  );
}
